module.exports = __webpack_public_path__ + "static/img/3.3e0a87e.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/5/2/zh/3.png
// module id = KY5f
// module chunks = 0